import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import { ThreeDots } from "react-loader-spinner";
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import Flags from "country-flag-icons/react/3x2";
//import ReactCountryFlag from "react-country-flag"
//import CountryData from 'country-data'
import PlayerFlag from './PlayerFlag'
import PlayerGames from './PlayerGames'
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from "react-router-dom";

const delay = ms => new Promise(res => setTimeout(res, ms));

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function FindPlayers(props) {
    const [searchString, setSearchString] = useState("");
    const [exactMatch, setExactMatch] = useState(false);
    const [searchStatus, setSearchStatus] = useState();
    const [searchStatusColor, setSearchStatusColor] = useState();
    const [players, setPlayers] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState();
    const [searching, setSearching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [includeGamesOfSameName, setIncludeGamesOfSameName] = useState(false);
    const [excludeBlitzGames, setExcludeBlitzGames] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userRole, setUserRole] = useState("");
    const [selectPlayer, setSelectPlayer] = useState(props.selectPlayer ? props.selectPlayer : false);

    useEffect(async () => {
        setAuthenticated(await authService.isAuthenticated());
        var user = await authService.getUser();
        if (user != null) {
            var role = user.role;
            setUserRole(role);
            if (role.includes("Administrators"))
                setIsAdmin(true);
        }
    }, []);
    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "fideTitle",
            label: "Title",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "fideWomenTitle",
            label: "Women Title",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "fideBirthday",
            label: "Birthday Year",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "fideCountry",
            label: "Flag",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortOrder: { name: 'id', direction: 'desc' },
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        <PlayerFlag key={value} code={(value === "" || value === null || value === undefined) ? "USA" : value} />
                    </div>
                )
            }
        },
        {
            name: "fideCountry",
            label: "Country",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        <span>{value ? value : "USA"}</span>
                    </div >

                )
            }
        },
        {
            name: "uscfState",
            label: "State",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <span>
                        {value === "" ? "--" : value}
                    </span>
                )
            }
        },
        {
            name: "fideName",
            label: "Name",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    //<span>
                    //    {/*{value === "" ? tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName : value}*/}
                    //    {value ? value : players[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName}
                    //</span>
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let idType = rowPlayer.fidePlayerId > 0 ? "FIDE" : "USCF";
                    let id = rowPlayer.fidePlayerId > 0 ? rowPlayer.fidePlayerId : rowPlayer.uscfPlayerId;
                    return (
                        /*<Button size="small">*/
                            <Link target="_blank" to={'/players/details?idtype='+idType+'&id='+id} className="button">
                                {/*{value ? value : players[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName}*/}
                                {value ? value : rowPlayer.uscfName}
                            </Link>
                        /*</Button>*/
                    )
                }
            }
        },
        {
            name: "fidePlayerId",
            label: "FIDE ID",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let birthYear = rowPlayer.fideBirthday;
                    return (
                        <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value} [{birthYear}]</a>) : (value)}</div>
                    );
                }
            }
        },
        {
            name: "fideRating",
            label: "Elo",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let fideId = rowPlayer.fidePlayerId;
                    return (
                        <div style={{ textAlign: "left" }}> {fideId != -1 ? (<a href={'https://ratings.fide.com/profile/' + fideId + "/calculations"} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                    );
                }
            }
        },
        {
            name: "fideBlitzRating",
            label: "FIDE Blitz",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "fideRapidRating",
            label: "FIDE Rapid",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "uscfPlayerId",
            label: "USCF ID",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                    );
                }
            }
        },
        {
            name: "uscfRating",
            label: "Rating",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,

                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let uscfId = rowPlayer.uscfPlayerId;
                    return (
                        <div style={{ textAlign: "left" }}> {uscfId != -1 ? (<a href={'https://www.uschess.org/msa/MbrDtlTnmtHst.php?' + uscfId} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                    );
                }
            }
        },
        {
            name: "uscfOnlineRating",
            label: "USCF Online",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "uscfBlitzRating",
            label: "USCF Blitz",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "uscfOnlineBlitzRating",
            label: "USCF Online Blitz",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "uscfQuickRating",
            label: "USCF Quick",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "uscfOnlineQuickRating",
            label: "USCF Online Quick",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let idType = rowPlayer.fidePlayerId > 0 ? "FIDE" : "USCF";
                    let id = rowPlayer.fidePlayerId > 0 ? rowPlayer.fidePlayerId : rowPlayer.uscfPlayerId;
                    return (
                        //<div>
                        //    {/*<div style={{ textAlign: "left" }}> <Button variant="contained" onClick={async (e) => { e.preventDefault(); await setSelectedPlayer(rowPlayer) }}>Games</Button></div>*/}
                        //    <LoadingButton
                        //        sx={{ textTransform: "none" }}
                        //        fullWidth
                        //        onClick={async (e) => { e.preventDefault(); await setLoading(true); await setSelectedPlayer(rowPlayer); await delay(2000);await setLoading(false) }} loading={loading}
                        //        loadingIndicator="Loading..."
                        //        variant="contained">
                        //        Games
                        //    </LoadingButton>
                        <Button component={Link} target="_blank" to={'/players/details?idtype=' + idType + '&id=' + id} variant="contained" color="primary">
                                Games
                        </Button>
                    );
                }
            }
        }
    ];

    const options = {
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        filter: true,
        filterType: 'dropdown',
        responsive: "vertical",
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: [5],
        rowsPerPageOptions: [5, 10, 15, 25, 50],
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
        onRowClick: (rowData,rowMeta) => {
            const detail = players[rowMeta.dataIndex];
            console.log(detail);
            if (props.sendToParentSelectedPlayer) {
                props.sendToParentSelectedPlayer(detail)
            }
            if (detail.fidePlayerId > 0) {
                if (props.sendToParentIdType) {
                    props.sendToParentIdType("FIDE")
                }
                if (props.sendToParentPlayerId) {
                    props.sendToParentPlayerId(detail.fidePlayerId)
                }
            } else {
                if (props.sendToParentIdType) {
                    props.sendToParentIdType("USCF")
                }
                if (props.sendToParentPlayerId) {
                    props.sendToParentPlayerId(detail.uscfPlayerId)
                }
            }
        }
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };



    const findPlayers = async (e, searchString) => {
        if (searchString === "") {
            e.preventDefault();
            setSearchStatus("Please enter player names or ID");
            setSearchStatusColor("red");
            setLoading(false);
        }
        else {
            e.preventDefault();
            setSearching(true);
            var token = await authService.getAccessToken();
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            axios.get('/api/ChessPlayers/FindPlayer?searchString=' + searchString + '&exactMatch=' + exactMatch, headers).then((response) => {
                const serachResults = response.data;
                setPlayers(serachResults);
                setSearchStatus(serachResults.length + ' players found by searching "' + searchString + '"');
                setSearchStatusColor("green");
                setSearching(false);
                setLoading(false);
            }).catch((error) => {
                setSearchStatusColor("red");
                setPlayers([]);
                setSearchStatus(error.response.data);
                setSearching(false);
                setLoading(false);
            });
        }
    };


    const handleKeyDown = e => {
        const trimmedText = e.target.value.trim()
        // If the user pressed the Enter key:
        if (e.key === 'Enter' && trimmedText) {
            setLoading(true);
            findPlayers(e, searchString);
            setSelectedPlayer(null);
        }
    }

    return (
        <Box sx={{ pt: 2, pb: 1 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1}  justify-content="space-between" align-items="stretch">
                <Grid item xs={7} lg={6}>
                        <TextField
                            size="small"
                            fullWidth
                            id="searchString"
                            label={"Enter player's ID or Name (e.g. 1234567 | Santa Clause )"}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={searchString}
                        onChange={async (e) => { await setSearchString(e.target.value) }}
                        onKeyDown={handleKeyDown}
                        />
                </Grid>
                <Grid item xs={5} lg={2}>
                    <FormControlLabel control={<Checkbox checked={exactMatch } onChange={e => { setExactMatch(e.target.checked); }} />} label="Exact Match" />
                </Grid>
                <Grid item xs={12} lg={4}>
                    {/*<Stack spacing={1} direction="row" justifyContent="end">*/}
                    <LoadingButton sx={{ textTransform: "none" }} endIcon={<PersonSearchIcon />} fullWidth onClick={async (e) => { await setLoading(true); await findPlayers(e, searchString); setSelectedPlayer(null) }} loading={loading} loadingIndicator="Loading..." variant="contained">{props.searchButtonCaption ? props.searchButtonCaption : "Search Players & Download Games"}</LoadingButton>
                    {/*</Stack>*/}
                </Grid>
                {/*<Grid item xs={12} lg={1}>*/}
                {/*    */}{/*<Stack spacing={1} direction="row" justifyContent="end">*/}
                {/*    */}{/*<Button endIcon={<ClearAllIcon/>} fullWidth variant="outlined" onClick={async (e) => { e.preventDefault(); await setSearchString(""); await setSearchStatus(""); await setPlayers([]); await setSelectedPlayer() }}>{props.clearButtonCaption ? props.clearButtonCaption : "Clear"}</Button>*/}
                {/*    */}{/*</Stack>*/}
                {/*    */}{/*<Link to="/Contribute" className="btn btn-primary"><Button variant="contained" color="secondary">Contribute</Button></Link>*/}
                {/*    <Link fullWidth to="/Contribute" className="btn btn-success fullWidth">Contribute</Link>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} lg={1}>*/}
                {/*    <Button sx={{ textTransform: "none" }} fullWidth variant="contained" color="secondary" href="/Contribute">Contribute</Button>*/}
                {/*</Grid>*/}
                {searching &&
                    <Grid item xs={12}>
                        <div style={{ zIndex: 99, position: 'fixed', top: '20%', left: '50%' }}>
                            <span> <ThreeDots ariaLabel="Searching " color="#00BFFF" /></span>
                        </div>
                    </Grid>
                }
                {players.length === 0 &&
                    <Grid item xs={12}>
                        <div>
                            <span className="input-group-addon mt-1 mb-1 ml-1" style={{ color: searchStatusColor }}>{searchStatus}</span>
                        </div>
                    </Grid>
                }
                {selectedPlayer &&
                    <Grid item xs={12}>
                    <PlayerGames key={selectedPlayer.uscfPlayerId + selectedPlayer.fidePlayerId} player={selectedPlayer} includeGamesOfSameName={includeGamesOfSameName} excludeBlitzGames={excludeBlitzGames}/>
                    </Grid>
                }
                {/*{players.length > 0 &&*/}
                {/*    <Grid item xs={12}>*/}
                {/*        <div className="mt-10 mb-10">*/}
                {/*            <FormGroup>*/}
                {/*                <FormControlLabel control={<Checkbox disabled={!authenticated}*/}
                {/*                    onChange={e => {*/}
                {/*                        setExcludeBlitzGames(e.target.checked);*/}
                {/*                    }}*/}
                {/*            />} label="Exclude Blitz Games [Log in required]" />*/}
                {/*            </FormGroup>*/}
                {/*        </div>*/}
                {/*    </Grid>*/}
                {/*}*/}
                {/*{players.length > 0 &&*/}
                {/*    <Grid item xs={12}>*/}
                {/*        <div className="mt-10 mb-10">*/}
                {/*            <FormGroup>*/}
                {/*                <FormControlLabel control={<Checkbox disabled={!authenticated}*/}
                {/*                    onChange={e => {*/}
                {/*                        setIncludeGamesOfSameName(e.target.checked);*/}
                {/*                    }}*/}
                {/*                />} label="Include untagged games with similar names [Log in required]" />*/}
                {/*            </FormGroup>*/}
                {/*        </div>*/}
                {/*    </Grid>*/}
                {/*}*/}
                {players.length > 0 &&
                    <Grid item xs={12}>
                    <div className="mt-10 mb-10">
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                    /*title={players.length + " player(s) found by searching " + '"' + searchString + '"'}*/
                                    title={
                                        <div>
                                            <Button variant="contained" color="secondary"
                                                onClick={async (e) => { e.preventDefault(); await setSearchString(""); await setSearchStatus(""); await setPlayers([]); await setSelectedPlayer(); /*await setSelectedUser(); await setSearchString("")*/ }}>
                                                {"Clear Results"}
                                            </Button>
                                            <span>&nbsp;&nbsp;{players.length + " player(s) found by searching " + '"' + searchString + '"'}</span>
                                        </div>
                                    }
                                    data={players}
                                    columns={columns}
                                    options={options}
                                    components={components}
                                />
                            </ThemeProvider>
                        </CacheProvider>
                    </div>
                    </Grid>
                }
                {/*{players.length > 0 &&*/}
                {/*    <Grid item xs={12}>*/}
                {/*        <div className="mt-10 mb-10">*/}
                {/*            <FormGroup>*/}
                {/*                <FormControlLabel control={<Checkbox disabled={!authenticated}*/}
                {/*                    onChange={e => {*/}
                {/*                        setIncludeGamesOfSameName(e.target.checked);*/}
                {/*                    }}*/}
                {/*            />} label="Include untagged games with similar names [Log in required]" />*/}
                {/*            </FormGroup>*/}
                {/*        </div>*/}
                {/*    </Grid>*/}
                {/*}*/}
                {/*{selectedPlayer && */}
                {/*    <Grid item xs={12}>*/}
                {/*    <PlayerGames key={selectedPlayer.uscfPlayerId+selectedPlayer.fidePlayerId} player={selectedPlayer}/>*/}
                {/*    </Grid>*/}
                {/*}*/}
                
            </Grid>
        </Box>
        )
}

